import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ReadingSkillsMasteredCohortStudentsResultsController extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage', 'gradePosition']

  @tracked sort = 'first_name'

  @tracked pageNumber = 1

  @tracked perPage = 10

  @tracked gradePosition = 1
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/re/skills-mastered/cohort/students-results': ReadingSkillsMasteredCohortStudentsResultsController
  }
}
